import { Box, BoxProps, CircularProgress, styled } from '@mui/material';

type TProps = BoxProps & {
  size?: number;
};

const LoadingWrapper = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '200px',
}));

const ContainerLoading = (props: TProps) => (
  <LoadingWrapper {...props}>
    <CircularProgress size={props.size || 64} />
  </LoadingWrapper>
);
export default ContainerLoading;
